import { render } from "./CouponsView.vue?vue&type=template&id=e1afc952&scoped=true"
import script from "./CouponsView.vue?vue&type=script&lang=js"
export * from "./CouponsView.vue?vue&type=script&lang=js"

import "./CouponsView.vue?vue&type=style&index=0&id=e1afc952&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1afc952"]])

export default __exports__